import { JSX } from "react";

export type IconName =
    | "agression"
    | "ai-assistent"
    | "ai-generate"
    | "ai-model"
    | "alarm"
    | "alarm-light"
    | "alert"
    | "alert-filled"
    | "app"
    | "appoint"
    | "archive"
    | "arrow-bottom"
    | "arrow-left"
    | "arrow-right"
    | "arrow-right-left"
    | "arrow-top"
    | "arrow-triangle-left"
    | "arrow-triangle-right"
    | "attachment"
    | "attractions"
    | "author"
    | "batch"
    | "battery-0"
    | "battery-1-25"
    | "battery-26-50"
    | "battery-51-75"
    | "battery-76-100"
    | "battery-unknown"
    | "bike"
    | "bike-electric"
    | "bike-folding"
    | "bike-freight"
    | "bike-freight-electric"
    | "bike-freight-share"
    | "bike-share"
    | "bike-shed"
    | "bike-shed-covered"
    | "binoculars"
    | "book"
    | "booking"
    | "bookmark-star"
    | "bookshelf"
    | "book-warning"
    | "bug"
    | "building"
    | "bus"
    | "bus-alt"
    | "business"
    | "calendar"
    | "calendar-thursday"
    | "car"
    | "card"
    | "card-conflict"
    | "card-ov-chipkaart"
    | "card-paying"
    | "cart"
    | "check"
    | "check-circle"
    | "check-circle-filled"
    | "check-in"
    | "checklist"
    | "chevron-down"
    | "chevron-left"
    | "chevron-right"
    | "chevron-up"
    | "children"
    | "class-first"
    | "class-second"
    | "cleaning"
    | "clipboard"
    | "clipboard-add"
    | "clock"
    | "clock-plus"
    | "clock-extend"
    | "close"
    | "cloud"
    | "cloud-conflict"
    | "clouds-sunshine"
    | "coffee"
    | "coffee-mug"
    | "collapse"
    | "combine"
    | "comment"
    | "comment-alt"
    | "comment-alt-add"
    | "comments"
    | "components"
    | "conference-room"
    | "connect"
    | "copy"
    | "copy-to"
    | "counter"
    | "current-location"
    | "current-location-filled"
    | "dark-light-mode"
    | "dashboard"
    | "decrease"
    | "delay"
    | "denied-circle"
    | "departure-light"
    | "departure-light-conflict"
    | "departure-light-double"
    | "disconnect"
    | "disruption-filled"
    | "divide"
    | "dog"
    | "download"
    | "drag-indicator"
    | "duplicate"
    | "dwergsein"
    | "edit"
    | "edit-box"
    | "elephant"
    | "elevator"
    | "error"
    | "error-filled"
    | "escalator"
    | "euro"
    | "euro-down"
    | "euro-up"
    | "expand"
    | "external"
    | "eye"
    | "eye-conflict"
    | "feedback"
    | "ferry"
    | "file"
    | "file-doc"
    | "file-download"
    | "file-jpg"
    | "file-msg"
    | "file-pdf"
    | "file-plus"
    | "file-png"
    | "file-ppt"
    | "file-universal"
    | "file-upload"
    | "file-xls"
    | "file-xml"
    | "file-zip"
    | "filter"
    | "filter-alt"
    | "fire"
    | "first-aid-kit"
    | "flag"
    | "flash"
    | "flash-conflict"
    | "flex-work"
    | "folder"
    | "folder-add"
    | "folder-download"
    | "folder-upload"
    | "forklift-truck"
    | "fuel"
    | "gate-passage"
    | "glass-damage"
    | "globe"
    | "headset"
    | "heart"
    | "heart-conflict"
    | "heart-filled"
    | "help"
    | "history"
    | "home"
    | "hotel"
    | "hourglass"
    | "hsl"
    | "image"
    | "increase"
    | "info"
    | "info-filled"
    | "key"
    | "label"
    | "leaf-1"
    | "leaf-2"
    | "leaf-3"
    | "leaf-unknown"
    | "length"
    | "light-bulb"
    | "list"
    | "list-checked"
    | "list-numbered"
    | "loader"
    | "lock"
    | "lock-alt"
    | "lock-open"
    | "log-in"
    | "log-out"
    | "mail"
    | "mail-open"
    | "maintenance"
    | "maintenance-filled"
    | "man-woman"
    | "map"
    | "marker"
    | "marker-conflict-1"
    | "marker-conflict-2"
    | "marker-info"
    | "marker-warning"
    | "megaphone"
    | "megaphone-conflict"
    | "menu"
    | "menu-overflow-horizontal"
    | "menu-overflow-vertical"
    | "messages"
    | "metro"
    | "metro-alt"
    | "metro-m"
    | "minus"
    | "minus-circle"
    | "mobile-phone"
    | "moon"
    | "more-ns"
    | "move"
    | "museum"
    | "news"
    | "nota"
    | "notification"
    | "notifications-settings"
    | "objects"
    | "ov-chipkaart"
    | "overlap"
    | "page-templates"
    | "parking"
    | "pause"
    | "percentage"
    | "phone"
    | "photo"
    | "pin"
    | "pin-filled"
    | "plants"
    | "platform"
    | "play"
    | "plus"
    | "plus-circle"
    | "porto"
    | "position"
    | "power"
    | "p-plus-r"
    | "print"
    | "privacy"
    | "prohibited"
    | "prompt"
    | "qr-code"
    | "question"
    | "radar"
    | "rail"
    | "rail--bow"
    | "recharge"
    | "redirect"
    | "redo"
    | "refresh"
    | "reisregie-plus"
    | "repair"
    | "repeat"
    | "report"
    | "restaurant"
    | "round-trip"
    | "route"
    | "route-fork-left"
    | "route-fork-right"
    | "route-keep-left"
    | "route-keep-right"
    | "route-merge"
    | "route-roundabout"
    | "route-straight"
    | "route-turn-left"
    | "route-turn-right"
    | "route-turn-sharp-left"
    | "route-turn-sharp-right"
    | "route-turn-slight-left"
    | "route-turn-slight-right"
    | "rush-average"
    | "rush-busy"
    | "rush-calm"
    | "rush-calm-conflict"
    | "rush-overcrowded"
    | "rush-unknown"
    | "save"
    | "scan"
    | "scissor"
    | "scooter"
    | "scooter-share"
    | "search"
    | "seat"
    | "send"
    | "settings"
    | "shaking-hands"
    | "share-android"
    | "sharepoint"
    | "signature"
    | "smartwatch"
    | "smiley-happy"
    | "smiley-neutral"
    | "smiley-sad"
    | "snooze"
    | "solar-panel"
    | "sort"
    | "sort-down"
    | "sort-up"
    | "spare-time"
    | "speed"
    | "split"
    | "spray-can"
    | "standby"
    | "star"
    | "star-filled"
    | "station"
    | "step"
    | "step-electric"
    | "stop"
    | "street"
    | "subscription"
    | "suitcase"
    | "suitcase-questionmark"
    | "sun"
    | "swap-horizontal"
    | "swap-vertical"
    | "swipe"
    | "switch"
    | "table"
    | "target-audience"
    | "taxi"
    | "temperature"
    | "tent"
    | "thermometer"
    | "thumbs-down"
    | "thumbs-up"
    | "ticket"
    | "ticket-machine"
    | "tickets"
    | "timeline"
    | "timer"
    | "together"
    | "toilet"
    | "tour"
    | "traffic-cone"
    | "traffic-cone-conflict"
    | "traffic-cone-warning"
    | "train"
    | "train-conflict-1"
    | "train-conflict-2"
    | "train-doors"
    | "train-doors-conflict"
    | "train-exit-left"
    | "train-exit-right"
    | "train-highspeed"
    | "train-ic-alt"
    | "train-spr-alt"
    | "train-wash"
    | "tram"
    | "tram-alt"
    | "transfer"
    | "trash"
    | "tunnel"
    | "turn"
    | "undo"
    | "upload"
    | "user"
    | "user-left"
    | "user-plus"
    | "user-right"
    | "users"
    | "vco"
    | "verified"
    | "video"
    | "video-camera"
    | "volume-level-1"
    | "volume-level-2"
    | "volume-level-3"
    | "volume-mute"
    | "voucher"
    | "walk"
    | "walk-visually-impaired"
    | "waste"
    | "waste-container"
    | "waste-gft"
    | "waste-glass"
    | "waste-paper"
    | "waste-plastic"
    | "web"
    | "wheelchair"
    | "wifi"
    | "wifi-conflict-1"
    | "wifi-conflict-2"
    | "windmill"
    | "wrench";

export type IconSize = "m" | "xs";

export type IconStrokeWidth = "normal" | "thick";

type IconProps = Omit<JSX.IntrinsicElements["tractie-icon"], "name" | "size" | "strokeWidth"> & {
    name: IconName;
    size?: IconSize;
    alt?: string;
    strokeWidth?: IconStrokeWidth;
};

export function Icon(props: IconProps) {
    return <tractie-icon {...props} data-icon-name={props.name} />;
}
